<template>
  <li @click="selectContact(item)"
      class="list-group-item d-flex justify-content-between align-items-center">
    <div class="d-flex justify-content-center">
      <div class="avatar">
        <avatar :channel-id="item.channel_id"></avatar>
      </div>
      <span>
        <mdb-icon icon="thumbtack"/>
      </span>
    </div>
    <span class="contact-name">
      <span class="name-wrap">
        <span>{{ item.name }}</span>
        <img class="channel-img" :src="item.channel_img" v-if="!!item.channel_img">
        <span v-if="!!item.channel_img">&nbsp;{{ item.channel_id }}</span>
      </span>
      <span class="grey-text">{{ item.time }}</span>
    </span>
    <span class="d-flex justify-content-center align-items-center">
      <span v-if="(item.unread > 0)">
        <mdb-icon icon="comment"></mdb-icon>
      </span>
      <span @click.stop="removeContact(item.uid, index)">
        <mdb-icon class="del_user" far icon="eye-slash" />
      </span>
    </span>
  </li>
</template>

<script>
import Avatar from "./avatar.vue";
import mdbIcon from "mdbvue/src/components/Content/Fa";

export default {
  name: "mark-item",

  components: {
    mdbIcon,
    Avatar
  },

  props: {
    item: {
      type: Object,
      default() {
        return {
          channel_id: 0,
          name: "",
          channel_img: false,
          time: "",
          unread: 0,
        };
      }
    },
    index: {
      type: Number,
      default: 0
    }
  },

  methods: {
    removeContact(uid, index) {
      this.$emit("remove", {uid, index});
    },
    selectContact(item) {
      this.$emit("selected", item);
    }
  }
}
</script>

<style lang="scss">
  .fa-comment{
    color: #4e7cef;
  }
</style>
